function removeTrailingSlash(str) {
  return str.replace(/\/+$/, "");
}

export { removeTrailingSlash };
